import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "gridIsOpen", true);
        Vue.set(state, "formIsOpen", false);
        Vue.set(state, "emailTemplateFormOpen", false);
        Vue.set(state, "uniqueDurationGridIsOpen", false);
        Vue.set(state, "uniqueDurationFormIsOpen", false);
        Vue.set(state, "formIsOpen", false);
        Vue.set(state, "formIsOpen", false);
        Vue.set(state, "formIsOpen", false);
        Vue.set(state, "excelImportFormIsOpen", false);
    },
    setFormOpen(state) {
        state.formIsOpen = true;
        state.gridIsOpen = false;
        state.uniqueDurationGridIsOpen = false;
        state.uniqueDurationFormIsOpen = false;
        state.excelImportFormIsOpen = false;
    },
    setFormClose(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
        state.uniqueDurationGridIsOpen = false;
        state.uniqueDurationFormIsOpen = false;
        state.excelImportFormIsOpen = false;
    },
    setEmailTemplateFormOpen(state) {
        state.formIsOpen = false;
        state.gridIsOpen = false;
        state.emailTemplateFormOpen = true;
        state.uniqueDurationGridIsOpen = false;
        state.uniqueDurationFormIsOpen = false;
        state.excelImportFormIsOpen = false;
    },
    setEmailTemplateFormClose(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
        state.emailTemplateFormOpen = false;
        state.uniqueDurationGridIsOpen = false;
        state.uniqueDurationFormIsOpen = false;
        state.excelImportFormIsOpen = false;
    },
    setUniqueDurationFormOpen(state) {
        state.formIsOpen = false;
        state.gridIsOpen = false;
        state.emailTemplateFormOpen = false;
        state.uniqueDurationGridIsOpen = false;
        state.uniqueDurationFormIsOpen = true;
        state.excelImportFormIsOpen = false;
    },
    setUniqueDurationFormClose(state) {
        state.formIsOpen = false;
        state.gridIsOpen = false;
        state.emailTemplateFormOpen = false;
        state.uniqueDurationGridIsOpen = true;
        state.uniqueDurationFormIsOpen = false;
        state.excelImportFormIsOpen = false;
    },
    setExcelImportFormOpen(state) {
        state.formIsOpen = false;
        state.gridIsOpen = false;
        state.emailTemplateFormOpen = false;
        state.uniqueDurationGridIsOpen = false;
        state.uniqueDurationFormIsOpen = false;
        state.excelImportFormIsOpen = true;
    },
    setExcelImportFormClose(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
        state.emailTemplateFormOpen = false;
        state.uniqueDurationGridIsOpen = false;
        state.uniqueDurationFormIsOpen = false;
        state.excelImportFormIsOpen = false;
    }
}
